export const ru = {
    bannerPrice: 'Цена в объявлении'
};
